<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-container class="pb-0">
    <v-container
      class="flex-message-box pa-0 ma-0 mb-2"
      v-for="(msg, index) in messages"
      :key="index"
      :class="{ operator: msg.respondent == 'support' }"
    >
      <v-container class="wrapper-message-box pa-0 ma-0">
        <div class="d-flex justify-space-between gap-5 mb-4">
          <v-card-text class="text-caption pa-0"
            >{{ msg.user ? msg.user.firstname : "-" }}
            {{ msg.user ? msg.user.lastname : "-" }}</v-card-text
          >
        </div>
        <!-- <v-card-text
                    class="text-body-1 pa-0 rendered-message"
                    style="line-height: 26px;"
                    v-html="decodeURIComponent(msg.message)"
                >
                </v-card-text> -->
        <v-card-text
          class="text-body-1 pa-0 rendered-message"
          style="line-height: 26px"
          v-html="formattedMessage(msg.message)"
        >
        </v-card-text>
        <v-container v-if="msg.files.length > 0" class="pa-0">
          <!--image-->
          <div
            class="d-flex align-center mt-3"
            style="flex-wrap: wrap; column-gap: 0.5rem"
          >
            <div
              v-for="(file, index) in msg.files"
              :key="index"
              v-if="resolveImgExtension(file)"
            >
              <a :href="file.link" target="_blank">
                <img :src="file.link" class="attached-img" />
              </a>
            </div>
          </div>
          <!--document-->
          <div
            v-for="(file, index) in msg.files"
            :key="index"
            v-if="resolveDocExtension(file)"
            class="d-flex align-center gap-2 my-4"
          >
            <a
              :href="file.link"
              target="_blank"
              class="d-flex align-center gap-2 grey--text text--darken-2"
            >
              <img :src="resolveDocImg(file)" class="attached-file" />
              <v-card-text class="text-body-2 pa-0">
                {{ file.title ? file.title : "file" }} {{ file.extension }}
              </v-card-text>
            </a>
          </div>
        </v-container>
      </v-container>
      <v-card-text class="text-caption pa-0 mb-1" style="width: auto">{{
        msg.time
      }}</v-card-text>
    </v-container>
  </v-container>
</template>

<script>
import imageXlsx from "@/assets/ticket/xlsx.png";

export default {
  props: {
    messages: Array,
  },
  data() {
    return {};
  },
  methods: {
    resolveImgExtension(file) {
      if (
        file.extension === ".png" ||
        file.extension === ".jpg" ||
        file.extension === ".jpeg" ||
        file.extension === ".gif" ||
        file.extension === ".webp"
      ) {
        return "true";
      }
    },
    resolveDocExtension(file) {
      if (
        file.extension === ".pdf" ||
        file.extension === ".doc" ||
        file.extension === ".docx" ||
        file.extension === ".txt" ||
        file.extension === ".xlsx" ||
        file.extension === ".pptx"
      ) {
        return "true";
      }
    },
    resolveDocImg(file) {
      if (file.extension === ".pdf") {
        return "https://cdn-icons-png.flaticon.com/512/11180/11180756.png";
      }
      if (file.extension === ".xlsx") {
        return imageXlsx;
      }
    },
    formattedMessage(message) {
      // Ensure message is a string before using .replace()
      if (typeof message !== "string") {
        return message; // If not a string, just return as is (or return an empty string if needed)
      }

      // Regex to find URLs starting with http, https or /
      const urlRegex = /((https?:\/\/[^\s]+)|\/[^\s]+)/g;

      // Replace URLs with <a> tags and decode them
      return message.replace(urlRegex, (match) => {
        // Decode each URL to handle Persian or other special characters
        const decodedUrl = decodeURIComponent(match);
        return `<a href="${decodedUrl}" target="_blank" class="link-style">${decodedUrl}</a>`;
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.flex-message-box {
  display: flex;
  align-items: end;
  gap: 0.8rem;
}
.flex-message-box.operator {
  justify-content: end;
}
.flex-message-box .wrapper-message-box {
  min-width: 180px !important;
  max-width: 70% !important;
  width: max-content;
  padding: 16px !important;
  border-radius: 10px;
  border: 1px solid #999999;
  border-bottom-right-radius: 0;
  background-color: #fff;
}
.flex-message-box.operator .wrapper-message-box {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 10px;
  background-color: #b4dbff54;
  border: 1px solid #0066ff;
  order: 2;
}
.flex-message-box .wrapper-message-box .rendered-message {
  white-space: pre-wrap;
}
.flex-message-box .wrapper-message-box .attached-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid silver;
  padding: 5px;
  background-color: #fff;
}
.flex-message-box .wrapper-message-box .attached-file {
  width: 40px;
  height: 40px;
}
.flex-message-box .wrapper-message-box .rendered-message ::v-deep .link-style {
  cursor: pointer;
  color: #0066ff;
  text-decoration: underline !important;
}
/* dark mode */
.theme--dark .flex-message-box .wrapper-message-box {
  background-color: #2a2a2a;
  border-color: #444;
  color: #fff;
}

.theme--dark .flex-message-box.operator .wrapper-message-box {
  background-color: #1a3a5c;
  border-color: #0066ff;
}

.theme--dark .flex-message-box .wrapper-message-box .attached-img {
  background-color: #2a2a2a;
  border-color: #444;
}
</style>
